import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function getJobRoles(jobId: string) {
	const response = await fetch(`${apiEndpoint}/jobs/${jobId}/roles`, {
		method: 'GET',
		headers: await standardHeaders(),
		mode: 'cors'
	});
	if (response.ok) {
		return await response.json();
	}
	return [];
}